import React,{useEffect, useState} from 'react'
import { BreadCumb } from '../component/BreadCumb'
import { Content } from './Abouts/Content'
import { useParams } from "react-router-dom";
import { CeoMessage } from './Abouts/CeoMessage';
import { TeamStructure } from './Abouts/TeamStructure';
import { Financial } from './Abouts/Financial';
import { FinancialRating } from './Abouts/FinancialRating';
import { useSelector,useDispatch } from "react-redux";
import { Performance } from './Abouts/Performance';
import { abtPage, abtPagear, ceomessagePage, ceomessagePagear, tenderPage, tenderPagear } from '../service/apiService';
import { Tender } from './Abouts/Tender';
import loadjs from 'loadjs';
import Loading from 'react-fullscreen-loading';
import { Lang } from '../component/Language/Lang';


export const About = () => {
  const langData=useSelector(state=>state.cart);
  //loadjs('assets/js/main.js', () => {});
    const rootHtml = document.getElementById("root-html");
    if (rootHtml) {
     rootHtml.setAttribute("dir", langData.lang==='ar' ? "rtl" : "ltr");
     rootHtml.setAttribute("lang", langData.lang ? "rtl" : "ltr");
   }

  
  let { titleAbout } = useParams(); 
  const [loading,setLoading]=useState(true);
  const[titlename,setName]=useState(titleAbout);
  const[abtContent,setabtContent]=useState([]);
  const[ceoMess,setceomessContent]=useState([]);
  const[tenderData,settenderData]=useState([]);
  useEffect(() => {
   // window.scrollTo(0, 0);
    window.scrollTo({
      top: 100,
      behavior: 'smooth',
    })
    getAbtContent();
    getCeomessContent();
   // console.log(`/something/${titleAbout}`);
    setName(titleAbout);
    getTender();
},[titleAbout,langData]);

const getAbtContent=async()=>{
  setLoading(true);
  const aboutUs=langData.lang==='ar'?await abtPagear() :await abtPage();
  
  setabtContent(aboutUs.data.data);
  setLoading(false);
}

const getCeomessContent=async()=>{
  setLoading(true);
  const ceoMessContent=langData.lang==='ar'? await ceomessagePagear():await ceomessagePage();
  //console.log(ceoMessContent.data.data);
  setceomessContent(ceoMessContent.data.data);
  setLoading(false);
}
const getTender=async()=>{
  setLoading(true);
  const tenderData=langData.lang==='ar'? await tenderPagear() :await tenderPage();
  settenderData(tenderData.data.data);
  setLoading(false);
}

  return (
    <>
       <Loading  loading ={loading} background="rgb(36 36 36 / 17%)" loaderColor="#000000" />
    <BreadCumb bgImage={"url('/assets/img/banner/aboutupdated.jpg')"} routeLink={"about"} 
    mainRoute={Lang[langData.lang].homebread} 
    route={Lang[langData.lang].breadAbout} title={Lang[langData.lang].prdAbtBtn}/>
    {titleAbout==='about'?
    <Content abtData={abtContent} comtitle={Lang[langData.lang].cTitle}/>:
    titleAbout==='CEOmessage'?
    <CeoMessage ceoMessData={ceoMess}/>:
    titleAbout==='team'?
    <TeamStructure/>:
    titleAbout==='financial'?
    <Financial/>:
    titleAbout==='financialRating'? 
    <FinancialRating/>:
    titleAbout==='tender'?
    <Tender tenderData={tenderData}/>:
    titleAbout==='performance'?
    <Performance/>:
    <></>}
  
    </>
  )
}
